import Image from "next/image";

interface PrivatePartner {
  id: number;
  key: string;
  image: string;
  alt: string;
  description?: string;
  link?: string;
}

interface ScrollingBannerSectionProps {
  partners: PrivatePartner[];
}

export function ScrollingBannerSection({
  partners,
}: ScrollingBannerSectionProps) {
  if (!partners || partners.length === 0) {
    return null;
  }

  // Dupliquer les logos plusieurs fois pour un effet infini fluide
  const numberOfDuplications = 4;

  return (
    <div className="py-24" aria-label="Partenaires privés">
      <div className="relative overflow-hidden">
        <div className="flex items-center gap-10 w-max animate-marquee">
          {Array.from({ length: numberOfDuplications }, (_, dupIndex) =>
            partners.map((partner, partnerIndex) => {
              const key = `${partner.id}-${dupIndex}-${partnerIndex}`;
              const imageElement = (
                <Image
                  src={partner.image}
                  alt={partner.alt}
                  width={200}
                  height={144}
                  className="h-[60px] w-auto"
                />
              );

              if (partner.link) {
                return (
                  <a
                    key={key}
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={partner.alt}
                    className="inline-flex"
                  >
                    {imageElement}
                  </a>
                );
              }

              return (
                <span key={key} className="inline-flex">
                  {imageElement}
                </span>
              );
            })
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-25%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </div>
  );
}
